import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import transformMultilineStop from 'src/app/component/shared/others/multiline-stop';
import { darkTimepickerTheme } from '../../../shared/others/timepicker-field-theme';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/component/shared/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validateTripTimetable } from './timetable-trip-validation';
import { TimetableStop, TimetableTrip } from '../time-table-types';
import {
  BlockIdItem,
  RouteStops,
  TimetableByTripRequest,
  TimetableTripResponse,
  TimetableTripStop,
} from './trip-edit.type';
import {
  AddTimeTableData,
  ProgressTimetableService,
} from 'src/app/component/shared/services/progress-timetable.service';
import { NgForm } from '@angular/forms';

export interface TimeTableTripEditInput {
  trip: TimetableTrip;
  routeStops: RouteStops[];
  isEdit?: boolean;
  isOffset?: boolean;
  routeId?: string;
  routePattern?: number;
  tripDirection?: string;
  tripDate?: string;
  blockIdList?: BlockIdItem[];
}

@Component({
  selector: 'app-timetable-trip-edit',
  templateUrl: './timetable-trip-edit.component.html',
  styleUrls: ['./timetable-trip-edit.component.scss'],
})
export class TimetableTripEditComponent implements OnInit {
  constructor(
    private commonService: CommonService,
    private progressTimetableService: ProgressTimetableService,
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<TimetableTripEditComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: TimeTableTripEditInput
  ) {}
  timePickerTheme = darkTimepickerTheme;
  tripData: TimetableTrip;
  tripStops: RouteStops[];
  routePattern;
  routeId;
  tripDirection;
  tripDate;
  skipTrip = environment.features.timetable.skipTrip;
  project = environment.project;
  isEdit = false;
  isProcessing = false;
  blockIdList: BlockIdItem[] = [];

  @ViewChild('editForm') editForm!: NgForm;

  agencyId = '';
  initAgency() {
    this.agencyId = localStorage.getItem('agencyId');
  }

  ngOnInit() {
    this.initAgency();
    const {
      tripDirection,
      isEdit,
      routeId,
      routePattern,
      tripDate,
      routeStops,
      trip,
      blockIdList,
    } = this.dialogData || {};
    this.isEdit = isEdit;
    this.tripDirection = tripDirection;
    this.tripDate = tripDate;
    this.routeId = routeId;
    this.routePattern = routePattern;
    this.blockIdList = blockIdList;
    let tripCopy: TimetableTrip;
    if (this.isEdit) {
      tripCopy = JSON.parse(JSON.stringify(trip));
    } else {
      tripCopy = {
        blockId: '',
        tripId: '',
        direction: this.tripDirection,
        stops: [],
      };
    }
    this.tripStops = JSON.parse(JSON.stringify(routeStops));
    const mappedTripStops: TimetableStop[] = this.tripStops.map(stop => {
      const { stopCode, stopName, stopSequence } = stop;
      const multilineStop = transformMultilineStop(stopName);
      const baseStopData = {
        stopSequence: +stopSequence,
        stopId: stopCode,
        stopName,
        multilineStop,
        schArrTime: '',
      };

      // add
      if (!this.isEdit) {
        return {
          ...baseStopData,
          skip: false,
        };
      }

      // edit
      const timetableStop = tripCopy?.stops?.find(
        ttStop => ttStop.stopId === stopCode
      );
      if (timetableStop) {
        const { schArrTime } = timetableStop;
        return {
          ...baseStopData,
          schArrTime,
          skip: false,
        };
      }
      return {
        ...baseStopData,
        skip: true,
      };
    });

    this.tripData = {
      ...tripCopy,
      stops: mappedTripStops,
    };
    console.log('edit trip modal: ', { tripData: this.tripData, blockIdList });
  }

  onEdit() {
    if (this.isProcessing) return;

    if (this.editForm.valid) {
      console.log('Valid Form');
      console.log(this.tripData);
      const { routeId, tripDate } = this.dialogData;
      const { blockId: originalBlockId } = this.dialogData?.trip || {};
      const { tripId, blockId, direction, stops } = this.tripData;
      const blockIdFlag = originalBlockId !== blockId;
      const filteredStops = stops.filter(stop => !stop.skip);
      const mappedStops: TimetableTripStop[] = filteredStops.map(
        (stop, stopIndex) => {
          const { stopId, stopSequence, schArrTime } = stop;
          return {
            arrivalTime: schArrTime,
            stopId,
            stopSequence,
            // stopSequence: stopIndex + 1,
          };
        }
      );

      // validation

      const validatedResult = validateTripTimetable(filteredStops);
      console.log('Timetable Validation: ', validatedResult);
      // TODO: VALIDATION
      if (!validatedResult.valid) {
        this.snackbar.open(validatedResult.message, null, {
          panelClass: 'custom-snack-bar-panel-error',
          duration: 5000,
        });
        return;
      }
      this.isProcessing = true;
      const timetableUrl = this.isEdit
        ? environment.apiUrl.gtfs + `/v1/editUploadedTimetable/${tripId}`
        : environment.apiUrl.gtfs +
          `/v1/addTimetable/${this.agencyId}/${this.routeId}/${this.routePattern}/${this.tripDirection}/${blockId}/${this.tripDate}`;
      const editTripData: TimetableByTripRequest = {
        blockId: this.isEdit ? (blockIdFlag ? blockId : undefined) : blockId,
        blockIdFlag: this.isEdit ? blockIdFlag : undefined,
        timeOffSetFlag: this.isEdit ? false : undefined,
        timetableFlag: this.isEdit ? true : undefined,
        timetable: mappedStops,
      };
      const progressTimetableData: AddTimeTableData = {
        fileId: '',
        filename: this.isEdit
          ? `Edit Trip ${tripId}`
          : `Add Trip (${this.tripDate}) ${blockId}`,
        routeId,
        startDay: tripDate,
        endDay: tripDate,
        data: this.tripData,
        dataType: this.isEdit ? 'EDIT_TRIP' : 'ADD_TRIP',
      };
      const apiAction$ = this.commonService.commonPostFullUrlAction(
        timetableUrl,
        editTripData
      );

      console.log('Edit Trip Data: ', editTripData);

      // todo: add option to retry on error in progress timetable
      apiAction$.subscribe({
        next: (apiResponse: TimetableTripResponse) => {
          const { fileId } = apiResponse;
          this.progressTimetableService.add({
            ...progressTimetableData,
            fileId,
          });
          this.snackbar.open(
            `${routeId}: Trip ${tripId} is being ${
              this.isEdit ? 'updated' : 'created'
            }.`,
            null,
            {
              duration: 3000,
            }
          );
          console.log('Edit Trip: ', { tripId, apiResponse });
          this.isProcessing = false;
          this.dialogRef.close(this.tripData);
        },
        error: err => {
          this.isProcessing = false;
          console.error('Failed to edit timetable: ', routeId, tripId, {
            err,
          });
          this.snackbar.open(
            `Failed to ${
              this.isEdit ? `edit ${tripId}` : 'create trip'
            }. Please try again.`,
            null,
            {
              duration: 3000,
              panelClass: 'custom-snack-bar-panel-error',
            }
          );
        },
      });
      // this.dialogRef.close(this.tripData);
    } else {
      console.log('Invalid Form');
      this.editForm.form.markAllAsTouched();
    }
  }

  onDeleteTrip() {}

  getBlockName(id) {
    const block = this.blockIdList.find(block => block.id === id);
    if (block) {
      return block.name;
    }
    return '';
  }
}
